module.exports = __webpack_public_path__ + "static/media/ball_4_1.148c44c7.mp3";